<div class="meeting-details-view-container" *ngIf="iddTrainingTrainerObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info">
  </div>

  <div class="status-info">
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).meeting.write " (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>

  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" [fxFlex]="'100'" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail fxFlex="100" header="Imię" [value]="iddTrainingTrainerObject.firstName"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail fxFlex="100" header="Nazwisko" [value]="iddTrainingTrainerObject.lastName"></app-detail>

              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail fxFlex="100" header="Wykształcenie" [value]="iddTrainingTrainerObject.education"></app-detail>
              </div>


            </div>

            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="100">
                <app-detail fxFlex="100" header="Doświadczenie" [value]="iddTrainingTrainerObject.experience"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="100">
                <app-detail fxFlex="100" header="Notatka" [value]="iddTrainingTrainerObject.memo"></app-detail>

              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">

              <div fxFlex="100">
                <app-detail-bool fxFlex="100" header="Aktywny" [value]="iddTrainingTrainerObject.active"></app-detail-bool>

              </div>
            </div>


          </mat-card>
        </div>
      </div>
    </div>

  </div>


</div>
